import { render, staticRenderFns } from "./IndexAssessment.vue?vue&type=template&id=e755f88e"
import script from "./IndexAssessment.vue?vue&type=script&lang=js"
export * from "./IndexAssessment.vue?vue&type=script&lang=js"
import style0 from "./IndexAssessment.vue?vue&type=style&index=0&id=e755f88e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports